const COLLECTION_COPY = {
  all: "Engineered for the next headshot. Browse the entire Loadout arsenal.",
  keyboards: "Mechanical. Hall-effect. Magnetic. Every switch you need to dominate.",
  mice: "Ultralight shells, responsive sensors, 8K polling. Built for fast flicks, micro-corrections, and clean aim.",
  mousepads: "Speed, control, or balanced — the surface your aim was missing.",
  keycaps: "PBT doubleshot. Cherry, MT3, SA. The look of a serious battlestation.",
  audio: "Headsets, IEMs, DACs. Sound staging for competitive FPS and immersive RPGs.",
  switches: "Stock swaps, franken builds, hall-effect mods. Every switch you need.",
  accessories: "Hubs, cables, mounts. The small gear that completes the loadout.",
  "pcb-modules": "For custom builds and tinkerers. Replace, rebuild, upgrade.",
};

function capitalize(s) {
  const t = String(s || "");
  return t.charAt(0).toUpperCase() + t.slice(1);
}

export default function CollectionHero({
  handle,
  title,
  source,
  totalCount,
  visibleCount,
  intro,
}) {
  const displayTitle = capitalize(title || handle);
  const subtitle = intro || COLLECTION_COPY[handle] || COLLECTION_COPY.all;

  const showingCount =
    typeof visibleCount === "number" ? visibleCount : totalCount || 0;

  return (
    <section className="bg-[#0A0A0A] text-white border-b border-[#1F1F1F]">
      <div className="mx-auto max-w-[1440px] px-6 py-12 md:py-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div className="max-w-[720px]">
          <div className="font-mono text-[11px] uppercase tracking-[0.16em] text-[#FF9F1C]">
            COLLECTION · {handle.toUpperCase()}
          </div>
          <h1 className="mt-3 font-display text-white text-[36px] md:text-[56px] leading-[0.95]">
            {displayTitle}.
          </h1>
          <p data-testid="collection-intro" className="mt-4 font-sans text-[15px] md:text-[16px] text-[#8A8A8A] leading-relaxed">
            {subtitle}
          </p>
        </div>
        <div className="md:text-right">
          <div
            data-testid="collection-count"
            className="font-mono text-[11px] uppercase tracking-[0.08em] text-[#8A8A8A]"
          >
            Showing {showingCount} product{showingCount === 1 ? "" : "s"}
          </div>
        </div>
      </div>
    </section>
  );
}
